import type { TFunction } from 'i18next';

export const finishFailedText = (t: TFunction): string =>
  t('onboarding.finishFailed', 'Couldn’t save that you finished. Try again.');
